/**
 * Shared matching for excursion language filters.
 * Search forms may persist a language code (`de`) or a leftover numeric id (`3`).
 */

function addToken(set, value) {
  const raw = String(value ?? '').trim().toLowerCase();
  if (!raw || raw === '-1') return;
  set.add(raw);
  if (raw === 'en' || raw === 'gb' || raw === 'uk' || raw === 'eng') {
    set.add('en');
    set.add('gb');
    set.add('uk');
  }
  if (raw === 'el' || raw === 'gr') {
    set.add('el');
    set.add('gr');
  }
}

export function normalizeLanguageFilter(value) {
  if (value == null || value === '' || value === '-1') return null;
  const raw = String(value).trim();
  return raw || null;
}

export function languageFilterTokens(value) {
  const tokens = new Set();
  addToken(tokens, value);
  return tokens;
}

function firstPresent(...values) {
  for (const value of values) {
    if (value != null && value !== '') return value;
  }
  return null;
}

/** Schedules with no language_id are “all languages” / unguided options and match any filter. */
export function scheduleHasSpecificLanguage(schedule) {
  const languageId = firstPresent(
    schedule?.language_id,
    schedule?.language?.id,
    schedule?.languageId,
  );
  const languageCode = firstPresent(
    schedule?.language_code,
    schedule?.language?.code,
    schedule?.languageCode,
  );
  const languageName = firstPresent(
    schedule?.language_name,
    schedule?.language?.name,
    schedule?.languageName,
  );
  const hasId = languageId != null && Number(languageId) !== 0;
  const hasCode = languageCode != null && String(languageCode).trim() !== '';
  const hasName = languageName != null && String(languageName).trim() !== '';
  return Boolean(hasId || hasCode || hasName);
}

export function scheduleMatchesLanguage(schedule, languageFilter) {
  const selected = languageFilterTokens(languageFilter);
  if (selected.size === 0) return true;
  if (!scheduleHasSpecificLanguage(schedule)) return true;
  const candidates = [
    schedule?.language_code,
    schedule?.language?.code,
    schedule?.language_id,
    schedule?.language?.id,
  ];
  return candidates.some((candidate) => {
    if (candidate == null || candidate === '') return false;
    const tokens = languageFilterTokens(candidate);
    for (const token of tokens) {
      if (selected.has(token)) return true;
    }
    return false;
  });
}

export function optionMatchesLanguage(option, languageFilter) {
  const selected = languageFilterTokens(languageFilter);
  if (selected.size === 0) return true;
  return scheduleMatchesLanguage(
    {
      language_code: option?.languageCode,
      language_id: option?.languageId,
    },
    languageFilter,
  ) || (option?.languageCode && selected.has(String(option.languageCode).toLowerCase()));
}
